export const GET_REQUESTS = "GET_REQUESTS";
export const GET_REQUESTS_SUCCESS = "GET_REQUESTS_SUCCESS";
export const GET_REQUESTS_FAILURE = "GET_REQUESTS_FAILURE";

export const GET_SINGLE_REQUEST = "GET_SINGLE_REQUEST";
export const GET_SINGLE_REQUEST_SUCCESS = "GET_SINGLE_REQUEST_SUCCESS";
export const GET_SINGLE_REQUEST_FAILURE = "GET_SINGLE_REQUEST_FAILURE";

export const ADD_REQUEST = "ADD_REQUEST";
export const ADD_REQUEST_SUCCESS = "ADD_REQUEST_SUCCESS";
export const ADD_REQUEST_FAILURE = "ADD_REQUEST_FAILURE";

export const EDIT_REQUEST = "EDIT_REQUEST";
export const EDIT_REQUEST_SUCCESS = "EDIT_REQUEST_SUCCESS";
export const EDIT_REQUEST_FAILURE = "EDIT_REQUEST_FAILURE";

export const DELETE_REQUEST = "DELETE_REQUEST";
export const DELETE_REQUEST_SUCCESS = "DELETE_REQUEST_SUCCESS";
export const DELETE_REQUEST_FAILURE = "DELETE_REQUEST_FAILURE";
